module.exports = __webpack_public_path__ + "static/media/JUST.a62c4da0.png";